import { Directive, OnDestroy } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';

@Directive()
export abstract class DestroyableDirective implements OnDestroy {
  protected readonly _destroyed$ = new Subject();

  takeUntilDestroyed(): <T>(src: Observable<T>) => Observable<T> {
    return (src: Observable<any>) => src.pipe(takeUntil(this._destroyed$));
  }

  ionViewDidLeave() {
    this.ngOnDestroy();
  }

  ngOnDestroy(): void {
    this._destroyed$.next(null);
    this._destroyed$.complete();
  }
}
